import { useQuery } from '@tanstack/react-query';
import { useShallow } from 'zustand/react/shallow';

import { privateV2Api } from '@/lib/api-clients/rest-client';
import { useAccountStore } from '@/store/use-account-store';

export interface TransactionResponse {
  account_type: 0;
  action_id: string;
  amount: string;
  created_at: number;
  transaction_type: 0;
  user_id: string;
}

interface ResponseData {
  total: number;
  transactions: TransactionResponse[];
}

interface Params {
  limit?: number;
  offset?: number;
}

type QueryKey = [string, string | undefined, Params];

export const getTransactionsQueryKey = (
  apiKey: string | undefined,
  params?: Params,
) => ['/transactions', apiKey, params] as QueryKey;

export default function useTransactions(params: Params = {}) {
  const authParams = useAccountStore(
    useShallow((state) => {
      const authParams = state.getAuthParams(state.address);
      if (!authParams) return;
      return {
        apiKey: authParams.apiKey,
        accGroup: authParams.accountGroup,
      };
    }),
  );
  return useQuery({
    enabled: authParams?.accGroup === 2 && !!authParams?.apiKey,
    queryKey: getTransactionsQueryKey(authParams?.apiKey, params),
    queryFn: ({ queryKey: [_k, _a, params] }) =>
      privateV2Api.get<ResponseData>('/v2/transactions', { params }),
  });
}
